type Tone = "allow" | "ask" | "deny" | "neutral";

interface Props {
  label: string;
  value: number | string;
  delta?: string;
  tone?: Tone;
}

export function MetricCard({ label, value, delta, tone = "neutral" }: Props) {
  return (
    <div className="sr-metric">
      <div className="sr-metric__label">{label}</div>
      <div className={`sr-metric__value is-${tone}`}>{value}</div>
      {delta && <div className="sr-metric__delta">{delta}</div>}
    </div>
  );
}
